module.exports = __webpack_public_path__ + "assets/img/wave.5f3beb64.svg";